<template>
  <b-container class="introduction">
    <article
      :key="index"
      :id="`#${getSlug(item)}`"
      class="d-flex justify-content-between"
      v-for="(item, index) in items"
    >
      <div class="d-flex flex-column justify-content-center">
        <header>
          <h4 class="font-weight-bold">
            {{ item.ko.title }}<br />
            {{ item.en.title }}
          </h4>
        </header>
        <p>
          <span :key="i" v-for="(description, i) in item.ko.description">
            <span v-html="description" />
            <br />
          </span>
        </p>
        <p>
          <span :key="i" v-for="(description, i) in item.en.description">
            <span v-html="description" />
            <br />
          </span>
        </p>
      </div>
      <nav class="flex-column justify-content-center" v-if="items.length > 1">
        <b-nav vertical>
          <li :key="i" class="nav-item" v-for="(menu, i) in items">
            <router-link
              :to="`#${getSlug(menu)}`"
              replace
              class="nav-link text-right font-weight-bold"
              :class="item === menu ? 'active' : null"
            >
              {{ menu.ko.title }}<br />
              {{ menu.en.title }}
            </router-link>
          </li>
        </b-nav>
      </nav>
    </article>
  </b-container>
</template>

<script>
import Vue from "vue";

export default Vue.component("introduction", {
  props: ["items"],
  watch: {
    "$route.hash": {
      handler() {
        if (!this.$route.hash) {
          return;
        }

        this.$nextTick(() => {
          const element = document.getElementById(this.$route.hash);
          if (!element) {
            return;
          }

          window.scrollTo(0, element.offsetTop - 132);
        });
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    getSlug(item) {
      return item.en.title.toLowerCase().replace(/ /g, "-");
    }
  }
});
</script>

<style lang="scss" scoped>
$grid-gutter-width: 10px;
@import "~bootstrap/scss/bootstrap-grid.scss";

article {
  @include media-breakpoint-up(lg) {
    height: calc(100vh - 88px);
  }

  nav {
    display: none;

    @include media-breakpoint-up(lg) {
      display: flex;
    }

    .nav-link {
      color: #7a7a7a;

      &:hover,
      &.active {
        color: black;
      }
    }
  }
}
</style>
